import * as path from "node:path";
import { checkHasProjectFile, readProjectFile, writeProjectFile, deleteProjectFile } from "@prismicio/plugin-kit/fs";
import { loadFile, builders, writeFile } from "magicast";
import { buildSrcPath } from "../lib/buildSrcPath.js";
import { rejectIfNecessary } from "../lib/rejectIfNecessary.js";
const NUXT_PRISMIC = "@nuxtjs/prismic";
const installDependencies = async ({ installDependencies: installDependencies2 }) => {
  await installDependencies2({
    dependencies: {
      [NUXT_PRISMIC]: "^4.0.0"
    },
    dev: true
  });
};
const configurePrismicModule = async ({ helpers }) => {
  let nuxtConfigFilename = "nuxt.config.js";
  if (!await checkHasProjectFile({ filename: nuxtConfigFilename, helpers })) {
    nuxtConfigFilename = "nuxt.config.ts";
    if (!await checkHasProjectFile({ filename: nuxtConfigFilename, helpers })) {
      return;
    }
  }
  const nuxtConfigPath = helpers.joinPathFromRoot(nuxtConfigFilename);
  const mod = await loadFile(nuxtConfigPath);
  const config = mod.exports.default.$type === "function-call" ? mod.exports.default.$args[0] : mod.exports.default;
  let hasInlinedConfiguration = false;
  const hasPrismicModuleRegistered = (config.modules || []).find((registration) => {
    if (typeof registration === "string") {
      return registration === NUXT_PRISMIC;
    } else if (Array.isArray(registration)) {
      hasInlinedConfiguration = !!registration[1];
      return registration[0] === NUXT_PRISMIC;
    }
    return false;
  });
  if (!hasPrismicModuleRegistered) {
    config.modules ||= [];
    config.modules.push(NUXT_PRISMIC);
  }
  if (!hasInlinedConfiguration) {
    mod.imports.$add({
      from: "./prismic.config.json",
      imported: "apiEndpoint"
    });
    mod.imports.$add({
      from: "./prismic.config.json",
      imported: "repositoryName"
    });
    config.prismic ||= {};
    config.prismic.endpoint = builders.raw("apiEndpoint || repositoryName");
  }
  await writeFile(mod, nuxtConfigPath);
};
const moveOrDeleteAppVue = async ({ helpers, options }) => {
  const filenameAppVue = await buildSrcPath({ filename: "app.vue", helpers });
  if (!await checkHasProjectFile({ filename: filenameAppVue, helpers })) {
    return;
  }
  const filecontentAppVue = await readProjectFile({
    filename: filenameAppVue,
    helpers,
    encoding: "utf-8"
  });
  if (!filecontentAppVue.includes("<NuxtWelcome")) {
    return;
  }
  const filenameIndexVue = await buildSrcPath({
    filename: path.join("pages/index.vue"),
    helpers
  });
  if (!await checkHasProjectFile({ filename: filenameIndexVue, helpers })) {
    await writeProjectFile({
      filename: filenameIndexVue,
      contents: filecontentAppVue,
      format: options.format,
      helpers
    });
  }
  await deleteProjectFile({
    filename: filenameAppVue,
    helpers
  });
};
const modifyPrismicConfig = async ({ helpers, options, actions }) => {
  const hasAppDirectory = await checkHasProjectFile({
    filename: "app",
    helpers
  });
  const hasSrcDirectory = await checkHasProjectFile({
    filename: "src",
    helpers
  });
  const project = await helpers.getProject();
  if ((hasAppDirectory || hasSrcDirectory) && project.config.libraries && JSON.stringify(project.config.libraries) === JSON.stringify(["./slices"])) {
    const sliceLibrary = await actions.readSliceLibrary({
      libraryID: project.config.libraries[0]
    });
    if (sliceLibrary.sliceIDs.length < 1) {
      project.config.libraries = hasAppDirectory ? ["./app/slices"] : ["./src/slices"];
    }
  }
  await helpers.updatePrismicConfig(project.config, {
    format: options.format
  });
};
const projectInit = async ({ installDependencies: _installDependencies }, context) => {
  rejectIfNecessary(await Promise.allSettled([
    installDependencies({ installDependencies: _installDependencies }),
    configurePrismicModule(context),
    moveOrDeleteAppVue(context),
    modifyPrismicConfig(context)
  ]));
};
export {
  projectInit
};
//# sourceMappingURL=project-init.js.map
